import { Hammer, Building2, Wrench, HardHat, Truck, Handshake } from "lucide-react";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  construction: "https://images.pexels.com/photos/31197870/pexels-photo-31197870.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  demolition: "https://images.unsplash.com/photo-1582490772231-20eb7d216852?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  renovation: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  scaffolding: "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  facade: "https://images.unsplash.com/photo-1691519552796-6fc0fbb9debe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sitePrep: "https://images.unsplash.com/photo-1616551569669-b60598758c4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    slug: "konstruktionsarbejde",
    icon: Hammer,
    title: "Konstruktionsarbejde",
    short: "Udførelse af praktiske og afgrænsede konstruktionsopgaver på bygge- og renoveringsprojekter.",
    long: "Vi udfører konkrete og klart definerede konstruktionsopgaver som en del af større bygge- og renoveringsprojekter. Arbejdet aftales individuelt og tilpasses projektets omfang, tidsplan og materialer.",
    image: IMAGES.construction,
    tasks: [
      "Montering og opbygning af bygningsdele",
      "Praktisk konstruktionsarbejde på pladsen",
      "Understøttende arbejde for hovedentreprenøren",
      "Afgrænsede delopgaver efter aftale",
    ],
    customers: ["Hovedentreprenører", "Byggevirksomheder", "Renoveringsfirmaer"],
    alt: "Stålkonstruktion under opførelse på byggeplads",
  },
  {
    slug: "nedrivning-og-demontering",
    icon: HardHat,
    title: "Nedrivning og demontering",
    short: "Kontrolleret nedrivning, demontering og fjernelse af eksisterende bygningsdele.",
    long: "Vi udfører kontrolleret nedrivning og demontering af eksisterende bygningsdele som led i renoverings- og byggeprojekter. Opgaverne planlægges, så nedrivningen sker sikkert og struktureret.",
    image: IMAGES.demolition,
    tasks: [
      "Nedrivning af vægge, gulve og bygningsdele",
      "Demontering af inventar og installationer",
      "Fjernelse og bortskaffelse af materialer",
      "Klargøring før renovering eller ombygning",
    ],
    customers: ["Renoveringsfirmaer", "Ejendomsselskaber", "Hovedentreprenører"],
    alt: "Gravemaskine ved kontrolleret nedrivning af murværk",
  },
  {
    slug: "renovering-og-ombygning",
    icon: Wrench,
    title: "Renovering og ombygning",
    short: "Assistance ved renovering, ombygning, forbedring og klargøring af eksisterende bygninger.",
    long: "Vi assisterer ved renovering og ombygning af eksisterende bygninger – fra klargøring til udførelse af aftalte arbejdsområder. Vi indgår fleksibelt i projektet efter behov.",
    image: IMAGES.renovation,
    tasks: [
      "Renovering af eksisterende bygninger",
      "Ombygning og forbedring af bygningsdele",
      "Klargøring før og efter renovering",
      "Praktisk assistance gennem projektet",
    ],
    customers: ["Ejendomsselskaber", "Bygherrer", "Renoveringsfirmaer"],
    alt: "Renovering af facade på skandinavisk bygning",
  },
  {
    slug: "opfoerelse-af-bygninger",
    icon: Building2,
    title: "Opførelse af bygninger",
    short: "Udførelse af bygge- og konstruktionsarbejde i forbindelse med opførelse af nye bygninger og bygningsdele.",
    long: "Vi udfører bygge- og konstruktionsarbejde i forbindelse med opførelse af nye bygninger og bygningsdele. Vi indgår som underentreprenør eller selvstændig leverandør på nybyggeri.",
    image: IMAGES.scaffolding,
    tasks: [
      "Opførelse af nye bygningsdele",
      "Konstruktionsarbejde ved nybyggeri",
      "Understøttende byggeopgaver",
      "Afgrænsede delentrepriser",
    ],
    customers: ["Hovedentreprenører", "Byggevirksomheder", "Bygherrer"],
    alt: "Nybyggeri med stillads under opførelse",
  },
  {
    slug: "byggepladsservice",
    icon: Truck,
    title: "Byggepladsservice",
    short: "Materialehåndtering, klargøring, oprydning og øvrige praktiske opgaver på byggepladsen.",
    long: "Vi løser praktiske opgaver på byggepladsen, så projektet holdes i gang. Det omfatter materialehåndtering, klargøring, oprydning og øvrig praktisk støtte.",
    image: IMAGES.sitePrep,
    tasks: [
      "Materialehåndtering og logistik på pladsen",
      "Klargøring af byggeplads",
      "Oprydning under og efter arbejdet",
      "Øvrige praktiske byggepladsopgaver",
    ],
    customers: ["Hovedentreprenører", "Byggevirksomheder", "Entreprenører"],
    alt: "Klargøring og oprydning på byggeplads",
  },
  {
    slug: "underentreprise",
    icon: Handshake,
    title: "Underentreprise",
    short: "Fleksibel udførelse af aftalte arbejdsområder for hovedentreprenører og andre byggevirksomheder.",
    long: "Vi indgår som underentreprenør og udfører aftalte arbejdsområder for hovedentreprenører og andre byggevirksomheder. Vi tilbyder ekstra kapacitet og en pålidelig ekstern samarbejdspartner.",
    image: IMAGES.facade,
    tasks: [
      "Aftalte delentrepriser",
      "Ekstra kapacitet i travle perioder",
      "Projektbaseret eller løbende samarbejde",
      "Klart afgrænsede arbejdsområder",
    ],
    customers: ["Hovedentreprenører", "Byggevirksomheder", "Entreprenørfirmaer"],
    alt: "Samarbejde mellem entreprenører på byggeprojekt",
  },
];

export const NAV = [
  { to: "/", label: "Forside" },
  { to: "/ydelser", label: "Ydelser" },
  { to: "/om-os", label: "Om os" },
  { to: "/samarbejde", label: "Samarbejde" },
  { to: "/referencer", label: "Referencer" },
  { to: "/kontakt", label: "Kontakt" },
];
